module.exports = __webpack_public_path__ + "static/img/feature_a3.3e11fb2c.png";